/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-control-regex */
import React, { useState, useEffect, useCallback, Fragment } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory, Link, useLocation } from "react-router-dom";
import Breadcrumb from "../../common/breadcrumb";
import backend from "../../../api";
import { global_actions, auth_actions } from "../../../redux-store";
import { Notification } from "../../../utils";
import Modal from "react-responsive-modal";
import CommonAutocomplete from "../../../utils/CommonAutocomplete";
import MerchantTabs from "./components/MerchantTabs";
import MemberTabs from "./components/MemberTabs";
import axios from "axios";

const MerchantPreModal = ({ getCategories }) => {
  const { role } = useParams();
  const [modal, setModal] = useState(false);
  useEffect(() => {
    if (role === "merchant") {
      setModal(true);
      getCategories();
    }
  }, [role]);
  const close_modal = useCallback(() => {
    setModal(false);
  }, []);
  return (
    <Modal showCloseIcon={false} open={modal} onClose={() => {}} center>
      <MerchantTabs close_modal={close_modal} />
    </Modal>
  );
};

const MemberPreModal = (props) => {
  const { role } = useParams();
  const [modal, setModal] = useState(false);
  useEffect(() => {
    if (role === "member") {
      setModal(true);
    }
  }, [role]);
  const close_modal = useCallback(() => {
    setModal(false);
  }, []);
  return (
    <Modal showCloseIcon={false} open={modal} onClose={() => {}} center>
      <MemberTabs close_modal={close_modal} />
    </Modal>
  );
};

const Register = (props) => {
  const { handleSubmit, register, errors, getValues, setValue } = useForm();
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { role } = useParams();
  const [info, setInfo] = useState({ ip: "" });
  const [countries, setCountries] = useState([]);
  const [paymentType, setPaymentType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [paypalModal, setPaypalModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [venmoModal, setVenmoModal] = useState(false);
  const [store, setStore] = useState("");
  const [accountNo, setAccountNo] = useState("");
  const [cities, setCities] = useState([]);
  const [paymentinfo, setPaymentinfo] = useState("paypal_account");
  const [modal, setModal] = useState(false);
  const [categories, setCategories] = useState([]);

  const redirectQuery = new URLSearchParams(location.search).get("redirect");

  const getCategories = async () => {
    try {
      const response = await backend.get("/category", {
        params: { isActive: true, category_type: "business" },
      });
      setCategories(response?.data?.data);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  const URL = "https://ip.nf/me.json";
  useEffect(() => {
    axios.get(URL).then(({ data }) => {
      setInfo({ ...data });
    });
  }, []);

  useEffect(() => {
    if (["merchant", "customer", "member"].every((i) => i !== role)) {
      history.replace(`${process.env.PUBLIC_URL}/404`);
    } else {
      dispatch(global_actions.loading(true));
      const status = new Notification();
      backend
        .get("/country")
        .then(({ data }) => {
          if (data.data) setCountries(data.data);
        })
        .catch((error) => {
          status.set_toast(
            "error",
            error.response ? error.response.data.message : error.message
          );
        })
        .finally(() => {
          dispatch(global_actions.loading(false));
          status.show_toast();
        });
    }
  }, []);

  useEffect(() => {
    if (user) {
      setModal(true);
    }
  }, [user]);

  useEffect(() => {
    if (modal && user) {
      setModal(false);
      if (role === "customer") {
        history.replace(redirectQuery || `${process.env.PUBLIC_URL}/`);
      } else {
        history.replace(`${process.env.PUBLIC_URL}/`);
      }
    }
  }, [user, redirectQuery, modal, history, role]);

  const registerHandler = () => {
    setIsSubmitting(true);
    let values = { ...getValues(), role };

    values.category = selectedCategory ? selectedCategory._id : null;

    // if (!values.category) {
    //   setIsSubmitting(false);
    //   return;
    // }

    if (values) {
      if (role === "customer") {
        let customer = {
          ...values,
          ip_address: info.ip.ip,
          address: {
            name: values.name,
            state: values.state,
            zip: values.zip,
            country: values.country,
            city: values.city,
          },
        };
        dispatch(auth_actions.register(customer));
      } else if (role === "member") {
        let member = {
          ...values,
          ip_address: info.ip.ip,
        };
        dispatch(auth_actions.register(member,history));
      } else if (role === "merchant") {
        let merchant = {
          ...values,
          ip_address: info.ip.ip,
          company_address: `${values.name}, ${values.city}, ${values.state} - ${values.zip}, ${values.country}`,
          // [["paypal_account", "bank_routing"].filter(
          //   (i) => i !== paymentinfo
          // )[0]]: undefined,
        };
        dispatch(auth_actions.register(merchant,history));
      }
    }
  };

  const payment = (e) => {
    setPaymentType(e.target.value);
  };

  const accountNumber = (val) => {
    setAccountNo(val);
  };

  const submitPaypal = () => {
    setPaypalModal(false);
  };

  const submitVenmo = () => {
    setVenmoModal(false);
  };
  const handleCategoryChange = (newValue) => {
    setSelectedCategory(newValue);
    setValue("category", newValue ? newValue._id : "", {
      shouldValidate: true,
    });
  };

  useEffect(() => {
    if (paymentType !== "") {
      if (paymentType === "paypal") {
        setPaypalModal(true);
      } else if (paymentType === "venmo") {
        setVenmoModal(true);
      }
    }
  }, [paymentType]);

  const setSelectState = (e) => {
    setStore(e.target.value);
  };

  return (
    <div>
      <Breadcrumb title={"create account"} />
      {/*Regsiter section*/}
      <section className="register-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3>
                create account &mdash; {role === "merchant" ? "Retailer" : role}
              </h3>
              <div className="theme-card">
                <form className="theme-form">
                  <div className="form-row">
                    <div className="col-md-4">
                      <label htmlFor="fname">First Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="fname"
                        name="first_name"
                        placeholder="First Name"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                        })}
                      />
                      <label htmlFor="fname" className="error">
                        {errors.first_name && errors.first_name.message}
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="mname">Middle Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="mname"
                        name="middle_name"
                        placeholder="Middle Name"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                        })}
                      />
                      <label htmlFor="mname" className="error">
                        {errors.middle_name && errors.middle_name.message}
                      </label>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="lname">Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="lname"
                        name="last_name"
                        placeholder="Last Name"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                        })}
                      />
                      <label htmlFor="lname" className="error">
                        {errors.last_name && errors.last_name.message}
                      </label>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-md-4">
                      <label htmlFor="email">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Email"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                          pattern: {
                            value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                            message: "This must be a valid Email",
                          },
                        })}
                      />
                      <label htmlFor="email" className="error">
                        {errors.email && errors.email.message}
                      </label>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="cell">Phone Number:</label>
                      <input
                        type="number"
                        className="form-control"
                        id="cell"
                        placeholder="Enter your number"
                        name="phone"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                        })}
                      />
                      <label htmlFor="cell" className="error">
                        {errors.number && errors.number.message}
                      </label>
                    </div>
                    {/* <div className='col-md-4'>
                      <label htmlFor='mailing'>Mailing Address</label>
                      <input
                        type='text'
                        className='form-control'
                        id='mailing'
                        placeholder='Enter your address'
                        name='address'
                        ref={register({
                          required: {
                            value: true,
                            message: 'This Field is Required',
                          },
                        })}
                      />
                      <label htmlFor='mailing' className='error'>
                        {errors.address && errors.address.message}
                      </label>
                    </div> */}
                  </div>
                  <div className="form-row">
                    <div className="col-md-6">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        placeholder="Enter your password"
                        name="password"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                          minLength: {
                            value: 8,
                            message: "Password must have at least 8 characters",
                          },
                        })}
                      />
                      <label htmlFor="password" className="error">
                        {errors.password && errors.password.message}
                      </label>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="conf_password">Confirm Password</label>
                      <input
                        type="password"
                        className="form-control"
                        id="conf_password"
                        placeholder="Re-enter your password"
                        name="conf_password"
                        ref={register({
                          required: {
                            value: true,
                            message: "This Field is Required",
                          },
                          minLength: {
                            value: 8,
                            message: "Password must have at least 8 characters",
                          },
                          validate: (v) =>
                            getValues().password === v ||
                            "Passwords are not same",
                        })}
                      />
                      <label htmlFor="conf_password" className="error">
                        {errors.conf_password && errors.conf_password.message}
                      </label>
                    </div>
                  </div>
                  {role === "customer" && (
                    <Fragment>
                      <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="name">Street Address</label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Street Address"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                          <label htmlFor="name" className="error">
                            {errors.name && errors.name.message}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="country">Country</label>
                          <select
                            className="form-control"
                            id="country"
                            type="text"
                            name="country"
                            ref={register({
                              required: {
                                value: true,
                                message: "Please Select a Country",
                              },
                            })}
                            onChange={(e) =>
                              e.target.value &&
                              setCities(
                                countries.find(
                                  (cn) => cn._id === e.target.value
                                ).cities
                              )
                            }
                          >
                            <option selected value="">
                              Select Country
                            </option>
                            {countries.map((cn) => (
                              <option value={cn._id} key={cn._id}>
                                {cn.country_name}
                              </option>
                            ))}
                          </select>

                          <label htmlFor="country" className="error">
                            {errors.country && errors.country.message}
                          </label>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="city">City</label>
                          <select
                            className="form-control"
                            id="city"
                            type="text"
                            name="city"
                            ref={register({
                              required: {
                                value: true,
                                message: "Please Select a City",
                              },
                            })}
                          >
                            <option selected value="">
                              Select Country First
                            </option>
                            {cities.map((cn) => (
                              <option value={cn._id} key={cn._id}>
                                {cn.city_name}
                              </option>
                            ))}
                          </select>

                          <label htmlFor="city" className="error">
                            {errors.city && errors.city.message}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="state">State</label>
                          <input
                            className="form-control"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                            type="text"
                            id="state"
                            name="state"
                            placeholder="State"
                          />
                          <label htmlFor="state" className="error">
                            {errors.state && errors.state.message}
                          </label>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="zip">Zip</label>
                          <input
                            className="form-control"
                            type="text"
                            id="zip"
                            name="zip"
                            placeholder="Zip"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                              pattern: {
                                value: /^[\d]+$/,
                                message: "This field must be a number",
                              },
                            })}
                          />
                          <label htmlFor="zip" className="error">
                            {errors.zip && errors.zip.message}
                          </label>
                        </div>
                      </div>
                    </Fragment>
                  )}
                  {role === "merchant" && (
                    <Fragment>
                      <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="cname">Company Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="cname"
                            name="company_name"
                            placeholder="Company Name"
                            ref={register({
                              required: {
                                value: true,
                                message: "This Field is Required",
                              },
                            })}
                          />
                          <label htmlFor="cname" className="error">
                            {errors.company_name && errors.company_name.message}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="jtitle">Job Title</label>
                          <input
                            type="text"
                            className="form-control"
                            id="jtitle"
                            name="job_title"
                            placeholder="Job Title"
                            ref={register({
                              required: {
                                value: true,
                                message: "This Field is Required",
                              },
                            })}
                          />
                          <label htmlFor="jtitle" className="error">
                            {errors.job_title && errors.job_title.message}
                          </label>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="name">Street Address</label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Street Address"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                          <label htmlFor="name" className="error">
                            {errors.name && errors.name.message}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="country">Country</label>
                          <input
                            type="text"
                            id="country"
                            name="country"
                            className="form-control"
                            placeholder="Country"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                          <label htmlFor="country" className="error">
                            {errors.country && errors.country.message}
                          </label>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="city">City</label>
                          <input
                            type="text"
                            id="city"
                            name="city"
                            className="form-control"
                            placeholder="City"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />

                          <label htmlFor="city" className="error">
                            {errors.city && errors.city.message}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="state">State</label>
                          <input
                            className="form-control"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                            type="text"
                            id="state"
                            name="state"
                            placeholder="State"
                          />
                          <label htmlFor="state" className="error">
                            {errors.state && errors.state.message}
                          </label>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="zip">Zip</label>
                          <input
                            className="form-control"
                            type="text"
                            id="zip"
                            name="zip"
                            placeholder="Zip"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                              pattern: {
                                value: /^[\d]+$/,
                                message: "This field must be a number",
                              },
                            })}
                          />
                          <label htmlFor="zip" className="error">
                            {errors.zip && errors.zip.message}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="category">Category</label>
                          <CommonAutocomplete
                            label="Select Category"
                            options={categories}
                            value={selectedCategory}
                            onChange={handleCategoryChange}
                            getOptionLabel={(option) => option.category_name}
                            isDisabled={false}
                            height={54}
                          />
                          <input
                            type="hidden"
                            name="category"
                            ref={register({
                              required: {
                                value: true,
                                message: "This Field is Required",
                              },
                            })}
                          />
                          {/* <input
                            className="form-control"
                            id="category"
                            type="text"
                            name="category"
                            placeholder="Category"
                            ref={register({
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          /> */}
                          {/* <label htmlFor="category" className="error">
                            {errors.category
                              ? errors.category.message
                              : "For example; Books, Music, Electronics etc."}
                          </label> */}
                          <label htmlFor="category" className="error">
                            {errors.category && errors.category.message}
                          </label>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="cweb">Company's Website</label>
                          <input
                            type="text"
                            className="form-control"
                            id="cweb"
                            name="website"
                            placeholder="Company's/Personal Website"
                            ref={register({
                              required: {
                                value: true,
                                message: "This Field is Required",
                              },
                            })}
                          />
                          <label htmlFor="cweb" className="error">
                            {errors.website && errors.website.message}
                          </label>
                        </div>
                      </div>
                      {/* <div className="form-row">
                        <div className="col-md-6">
                          <label htmlFor="broute">Receive Payments Via</label>
                          <div className="d-flex justify-content-start mt-3">
                            <input
                              type="radio"
                              className="form-control w-auto mx-5"
                              id="broute"
                              name="paypal_broute"
                              value="paypal_account"
                              checked={paymentinfo === "paypal_account"}
                              onChange={(e) => setPaymentinfo(e.target.value)}
                            />
                            <p>Paypal Account</p>
                          </div>
                          <div className="d-flex justify-content-start">
                            <input
                              type="radio"
                              className="form-control w-auto mx-5"
                              id="broute"
                              name="paypal_broute"
                              value="bank_routing"
                              checked={paymentinfo === "bank_routing"}
                              onChange={(e) => setPaymentinfo(e.target.value)}
                            />
                            <p>Bank's Routing Number</p>
                          </div>
                        </div>
                        {paymentinfo === "paypal_account" ? (
                          <div className="col-md-6">
                            <label htmlFor="paypinfo">Paypal Email</label>
                            <input
                              type="text"
                              className="form-control"
                              id="paypinfo"
                              name="paypal_account"
                              placeholder="Paypal Email"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This Field is Required",
                                },
                                pattern: {
                                  value: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
                                  message: "This must be a valid Email",
                                },
                              })}
                            />
                            <label htmlFor="paypinfo" className="error">
                              {errors.paypal_account &&
                                errors.paypal_account.message}
                            </label>
                          </div>
                        ) : (
                          <div className="col-md-6">
                            <label htmlFor="brouting">Bank's Routing No.</label>
                            <input
                              type="text"
                              className="form-control"
                              id="brouting"
                              name="bank_routing"
                              placeholder="Bank's Routing Number"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This Field is Required",
                                },
                              })}
                            />
                            <label htmlFor="brouting" className="error">
                              {errors.bank_routing &&
                                errors.bank_routing.message}
                            </label>
                          </div>
                        )}
                      </div> */}
                    </Fragment>
                  )}
                  {role === "member" && (
                    <>
                      <div className="box-head">
                        <h3>Security questions:</h3>
                      </div>
                      <div className="form-row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="question">
                              Enter the first name of your best friend:
                            </label>
                            <input
                              type="text"
                              className="form-control mb-0"
                              id="question"
                              name="member_bestfriend"
                              placeholder="Answer here"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This Field is Required",
                                },
                              })}
                            />
                            <label htmlFor="question" className="error">
                              {errors.member_bestfriend &&
                                errors.member_bestfriend.message}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="question">Favorite color:</label>
                            <input
                              type="text"
                              className="form-control mb-0"
                              id="question"
                              name="member_favorite_color"
                              placeholder="Answer here"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This Field is Required",
                                },
                              })}
                            />
                            <label htmlFor="question" className="error">
                              {errors.member_favorite_color &&
                                errors.member_favorite_color.message}
                            </label>
                          </div>
                        </div>
                      </div>
                      {/* <div className="box-head">
                        <h3>Payment Method:</h3>
                      </div>
                      <div className="form-row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="payment_method">
                              Payment Method
                            </label>
                            <select
                              id="payment_method"
                              value={paymentType}
                              className="form-control mb-0"
                              onChange={(e) => {
                                payment(e);
                              }}
                              name="member_payment_type"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "Please select a payment method",
                                },
                              })}
                            >
                              <option selected value="">
                                Select payment method
                              </option>
                              <option value="paypal">Paypal</option>
                              <option value="venmo">Venmo</option>
                              <option value="gift-card">Gift Card</option>
                            </select>
                            <label htmlFor="payment_method" className="error">
                              {errors.member_payment_type &&
                                errors.member_payment_type.message}
                            </label>
                          </div>
                        </div>
                        {paymentType === "gift-card" && (
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="store">Select Store</label>
                              <select
                                className="form-control mb-0"
                                name="gift_card_number"
                                id="store"
                                ref={register({
                                  required: {
                                    value: true,
                                    message: "This Field is Required",
                                  },
                                })}
                                defaultValue=""
                                onChange={(e) => {
                                  setSelectState(e);
                                }}
                              >
                                <option selected value="">
                                  Available Stores
                                </option>

                                <option value="amazon">Amazon</option>
                                <option value="ebay">Ebay</option>
                              </select>
                              <label htmlFor="store" className="error">
                                {errors.gift_card_number &&
                                  errors.gift_card_number.message}
                              </label>
                            </div>
                          </div>
                        )}
                      </div> */}
                    </>
                  )}
                  <div className="form-row">
                    <a
                      href="#"
                      className={`btn btn-solid ${
                        isSubmitting ? "disabled" : ""
                      }`}
                      onClick={
                        !isSubmitting ? handleSubmit(registerHandler) : null
                      }
                    >
                      Create Account
                    </a>
                    <Link
                      className="btn btn-light d-flex align-items-center"
                      to="/login"
                    >
                      Already have an Account?
                    </Link>
                    <Link to="/contact" className="ml-2 mt-4">
                      Need help?
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        open={modal}
        onClose={() => {
          if (user) {
            setModal(false);
            history.replace(`${process.env.PUBLIC_URL}/`);
          }
        }}
        center
      >
        {user && (
          <div className="container px-5 pt-5">
            <div className="row">
              <h2>Congratulations!</h2>
            </div>
            <div className="row">
              <p>You have now signed up as {user.role}.</p>
            </div>
            <br />
            <div className="row">
              <h2>{user && user.user.eksplode_code}</h2>
            </div>
            <div className="row">
              {" "}
              <p>
                Here is your eksplode! Code. You can use either this or your
                email to sign in
              </p>
            </div>
            <div className="row mt-3 justify-content-center">
              <button
                className="btn btn-solid"
                onClick={() => {
                  if (user) {
                    setModal(false);
                    history.replace(`${process.env.PUBLIC_URL}`);
                  }
                }}
              >
                Home
              </button>
              {user && user.role === "member" && (
                <button
                  className="btn btn-solid ml-3"
                  onClick={() => {
                    setModal(false);
                    // history.replace(
                    //   `${process.env.PUBLIC_URL}/dashboard/${user.role}/account`
                    // )
                  }}
                >
                  Members Club
                </button>
              )}
            </div>
          </div>
        )}
      </Modal>
      <MerchantPreModal getCategories={getCategories} />
      <MemberPreModal />
      <Modal
        open={paypalModal}
        onClose={() => {
          setPaypalModal(false);
          setPaymentType("");
        }}
        center
      >
        <div className="container px-5 pt-5 ">
          <div className="row">
            <h2 className="text-capitalize px-3">Enter Your Paypal Account</h2>
          </div>
          <br />

          <div className="form-row ">
            <div className="col-md-12">
              <label htmlFor="account">Account Number</label>
              <input
                type="text"
                className="form-control mb-0"
                id="account"
                name="payment_account_number"
                onChange={(e) => accountNumber(e.target.value)}
                ref={register({
                  required: {
                    value: true,
                    message: "This Field is Required",
                  },
                })}
              />
              <label htmlFor="account" className="error">
                {errors.payment_account_number &&
                  errors.payment_account_number.message}
              </label>
            </div>
          </div>
          <div className="row mt-3 justify-content-center">
            <button
              className="btn btn-solid mx-1"
              style={{ minWidth: "150px" }}
              onClick={handleSubmit(submitPaypal)}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        open={venmoModal}
        onClose={() => {
          setVenmoModal(false);
          setPaymentType("");
        }}
        center
      >
        <div className="container px-5 pt-5 custom-modal">
          <div className="row">
            <h2 className="text-capitalize px-3">Enter Your Venmo Account</h2>
          </div>
          <br />

          <div className="form-row ">
            <div className="col-md-12">
              <label htmlFor="account">Account Number</label>
              <input
                type="text"
                className="form-control mb-0 "
                id="account"
                name="account_number"
                onChange={(e) => accountNumber(e.target.value)}
                ref={register({
                  required: {
                    value: true,
                    message: "This Field is Required",
                  },
                })}
              />
              <label htmlFor="account" className="error">
                {errors.account_number && errors.account_number.message}
              </label>
            </div>
          </div>
        </div>
        <div className="row mt-3 justify-content-center">
          <button
            className="btn btn-solid mx-1"
            style={{ minWidth: "150px" }}
            onClick={handleSubmit(submitVenmo)}
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Register;
